const token = localStorage.getItem('token') ? 
                    'Bearer ' + localStorage.getItem('token') : '';
const URI = process.env.VUE_APP_QSSTORAGE;

export default {
  serverURI: URI,
  timeout: '50000', // 50 segundos
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Max-Age': 86400,
    // 'Authorization': token
  },
  fixedLayout: false,
  hideLogoOnMobile: false
}
